import React from "react";
import WebEditorRender from "../../../components/WebEditor";

/**
 * Section MAIN_CONTENT : rend `org.mainPage` via WebEditorRender.
 *
 * Pattern Ummah : la "page principale" de l'org est une page éditeur
 * (rich content) affichée historiquement en bas de la home. On la
 * réintègre comme une section modulaire 2026, à la position que veut
 * l'admin (drag-drop dans /web/theme onglet "Sections accueil").
 *
 * Si `org.mainPage` est absent → la section retourne null silencieusement.
 */
const styles = `
.t26-main-content {
  max-width: var(--container);
  margin-inline: auto;
  padding: clamp(24px, 4vw, 48px) clamp(16px, 4vw, 32px);
}
`;

export default function MainContent({ context }) {
    const { org } = context;
    if (!org?.mainPage) return null;

    let lang = context.lang?.value || null;
    const languages = org.languages || [];
    if (languages.length > 0 && !lang) lang = org.language;

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-main-content">
                <WebEditorRender page={org.mainPage} lang={lang} />
            </div>
        </>
    );
}
